module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"shopSearchPl":"在此处输入您的搜索内容"},"en":{"shopSearchPl":"Type your search here"}}')
  delete Component.options._Ctor
}
